import { titleLarge, cssSpacing, screenMdMax, titleMedium, Text, } from '@spotify-internal/encore-web/core';
import styled from 'styled-components';
import { TWO_COLUMN_MAX_WIDTH } from '../../../ui';
import { headlineNoNumbersLgScreen, headlineWithNumbersLgScreen, headlineNoNumbersMdScreen, headlineWithNumbersMdScreen, } from './gridColumns';
export const Headline = styled(Text) `
  grid-column: ${({ noNumbers }) => noNumbers ? headlineNoNumbersLgScreen : headlineWithNumbersLgScreen};
  grid-row: 1;
  ${titleLarge}
  padding-bottom: ${cssSpacing('looser-4')};
  @media (max-width: ${screenMdMax}) {
    grid-column: ${({ noNumbers }) => noNumbers ? headlineNoNumbersMdScreen : headlineWithNumbersMdScreen};
    ${titleMedium}
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    ${titleLarge}
    padding-bottom: ${cssSpacing('looser-3')};
    grid-row: ${({ noNumbers }) => (noNumbers ? 1 : 2)};
    grid-column: 1 / -1;
  }
`;
